import POSSelectorButton from '../../../Buttons/POSSelectorButton';

interface Props {
  selectedBrandName?: string;

  disabled?: boolean;

  onClick: () => void;
}

const POSBrandFilterCard = ({
  selectedBrandName,
  disabled,
  onClick,
}: Props) => {
  return (
    <POSSelectorButton
      label="Marca"
      value={selectedBrandName || 'Todas las marcas'}
      selected={!!selectedBrandName}
      disabled={disabled}
      onClick={onClick}
    />
  );
};

export default POSBrandFilterCard;
